import { FC } from "react";
import { Link } from "react-router-dom";
import { Box, HStack, Icon } from "@chakra-ui/react";
import { UserIcon } from "@heroicons/react/24/outline";

import { Logo } from "../../../shared/Logo";
import { RoutesMap } from "../../../../routes.tsx";

export const MainPageHeader: FC = () => {
  return (
    <HStack h="64px" alignItems="center" justifyContent="space-between" pl="9px">
      <Logo />

      <Box>
        <Link to={RoutesMap.profile}>
          <Box
            w={12}
            h={12}
            borderRadius="full"
            bg="gray.50"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Icon color="brand.500" as={UserIcon} boxSize={6} />
          </Box>
        </Link>
      </Box>
    </HStack>
  );
};
